/** Note: no support for octal notation (indicated by leading 0). */ var OCTET = '(?:25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]\\d|\\d)';
var HEXTET = '[0-9A-Fa-f]{1,4}';
var LEAD_HEXTET = "(?:".concat(HEXTET, ":)");
var TAIL_HEXTET = "(?::".concat(HEXTET, ")");
/** Note: doesn't contain a capture group, since it is embedded in the v6 syntax. */ var IP_V4_SYNTAX = "".concat(OCTET, "(?:\\.").concat(OCTET, "){3}");
/** Note: contains two capture groups: the address, and optional zone index. */ var IP_V6_SYNTAX = "(".concat([
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "".concat(LEAD_HEXTET, "{7}(?:").concat(HEXTET, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
    "".concat(LEAD_HEXTET, "{6}(?:").concat(IP_V4_SYNTAX, "|:").concat(HEXTET, "|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
    "".concat(LEAD_HEXTET, "{5}(?::").concat(IP_V4_SYNTAX, "|").concat(TAIL_HEXTET, "{1,2}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
    "".concat(LEAD_HEXTET, "{4}(?:").concat(TAIL_HEXTET, "{0,1}:").concat(IP_V4_SYNTAX, "|").concat(TAIL_HEXTET, "{1,3}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
    "".concat(LEAD_HEXTET, "{3}(?:").concat(TAIL_HEXTET, "{0,2}:").concat(IP_V4_SYNTAX, "|").concat(TAIL_HEXTET, "{1,4}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
    "".concat(LEAD_HEXTET, "{2}(?:").concat(TAIL_HEXTET, "{0,3}:").concat(IP_V4_SYNTAX, "|").concat(TAIL_HEXTET, "{1,5}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
    "".concat(HEXTET, ":(?:").concat(TAIL_HEXTET, "{0,4}:").concat(IP_V4_SYNTAX, "|").concat(TAIL_HEXTET, "{1,6}|:)"),
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
    "(?::(?:".concat(TAIL_HEXTET, "{0,5}:").concat(IP_V4_SYNTAX, "|").concat(TAIL_HEXTET, "{1,7}|:))")
].join('|'), ")(?:%([0-9a-zA-Z]+))?");
/**
 * Group 1: v4 address. Group 2: Optional CIDR (0-32).
 */ var IPv4_CIDR_RegEx = new RegExp("^(".concat(IP_V4_SYNTAX, ")(?:/(3[0-2]|[12]\\d|\\d))?$"));
/**
 * Group 1: v6 address. Group 2: Optional zoneIndex. Group 3: Optional CIDR (0-128).
 */ var IPv6_CIDR_RegEx = new RegExp("^".concat(IP_V6_SYNTAX, "(?:/(12[0-8]|1[01]\\d|[1-9]?\\d))?$"));
var isCIDRBlock = function isCIDRBlock(address) {
    return IPv4_CIDR_RegEx.test(address) || IPv6_CIDR_RegEx.test(address);
};
var isIPv4CIDRBlock = function isIPv4CIDRBlock(address) {
    return IPv4_CIDR_RegEx.test(address);
};
var isIPv6CIDRBlock = function isIPv6CIDRBlock(address) {
    return IPv6_CIDR_RegEx.test(address);
};
// These do not assert that the IPs are valid.
var LOCAL_v4 = /^(?:10|127|169\.254|172\.(?:1[6-9]|2\d|3[01])|192\.168)\./;
var LOCAL_v6 = /^(?:(?:(?:0::?)+|::)(?:(?:0\.){3})?1$|[fF][cCdD])/;
var isLocal = function isLocal(address) {
    var match;
    if (match = IPv4_CIDR_RegEx.exec(address)) {
        return LOCAL_v4.test(match[1]);
    }
    if (match = IPv6_CIDR_RegEx.exec(address)) {
        return LOCAL_v6.test(match[1]);
    }
    return false;
};
export var CIDRUtils = {
    isCIDRBlock: isCIDRBlock,
    isLocal: isLocal,
    isIPv4CIDRBlock: isIPv4CIDRBlock,
    isIPv6CIDRBlock: isIPv6CIDRBlock
};

//# sourceMappingURL=CIDRUtils.js.map